export default {
  common: {
    loading: 'Loading...',
    error: 'Error',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    noData: 'No data',
    justNow: 'just now',
    retry: 'Retry',
    reject: 'Reject',
    ago: 'ago',
    increase: 'Increase',
    decrease: 'Decrease',
  },
  auth: {
    login: 'Sign In',
    email: 'Email',
    emailRequired: 'Please enter your email address.',
    emailInvalid: 'Please enter a valid email address.',
    forgotPassword: 'Forgot password?',
    sendCode: 'Send Code',
    sendingCode: 'Sending...',
    codeSent: 'Verification code requested for {email}. Check your inbox; retry later if needed.',
    enterCode: 'Enter verification code',
    codeRequired: 'Please enter the 6-digit verification code.',
    codeInvalid: 'Verification code must be 6 digits.',
    verifyAndSignIn: 'Verify & Sign In',
    verifying: 'Verifying...',
    changeEmail: 'Change email',
    resendCode: 'Resend code',
    otpResendCountdown: 'Resend in {seconds}s',
    consentRequired: 'Please agree to the terms to continue.',
    consentAgreement: 'I agree to the {terms} and {privacy}',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    displayNameRequired: 'Please enter your display name.',
    featureOtel: 'OTel Observability',
    featureConfig: 'Config & Secrets',
    featureDeploy: 'One-Click Deploy',
    brandTitle: 'ServerlessInsight',
    brandTagline: 'Multi-cloud serverless infrastructure made visible and manageable.',
  },
  errors: {
    notFoundTitle: 'Page not found',
    notFoundDescription: "The page you're looking for doesn't exist or has been moved.",
    somethingWentWrong: 'Something went wrong',
  },
  legal: {
    terms: { title: 'Terms of Service' },
    privacy: { title: 'Privacy Policy' },
    refund: { title: 'Refund Policy' },
    termsSummary:
      'Covers accounts, acceptable use, the prepaid balance and billing model (top-up in advance, monthly closing-day billing, arrears repaid from the next top-up, balance never expires), no auto-renewal, MoR payments and refunds, and limitation of liability.',
    privacySummary:
      'We collect your email, billing ledger, and the infrastructure you declare; data is stored on Alibaba Cloud in mainland China (payments processed via our Merchant of Record); secret-type config items are AES-256-GCM encrypted; financial records are retained as required by accounting rules.',
    refundSummary:
      'Refundable = unconsumed and un-invoiced balance (minus in-flight refunds), arrears settled first; reviewed in 1–3 business days and returned to the original payment method; billing errors corrected unconditionally.',
    updated: 'Last updated: October 2026',
    readFull: 'Read the full document',
  },
  footer: {
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    refundPolicy: 'Refund Policy',
  },
  onboarding: {
    title: 'Welcome to ServerlessInsight',
    subtitle: "Let's get started by creating your first application.",
    orgNamePlaceholder: 'Organization name (optional)',
    displayNamePlaceholder: 'Your name',
    create: 'Create Application',
    creating: 'Creating...',
    skip: 'Skip for now',
  },
  profile: {
    title: 'Edit Profile',
    displayName: 'Display Name',
    displayNamePlaceholder: 'Your name',
    email: 'Email',
    save: 'Save',
    saving: 'Saving...',
    saveSuccess: 'Profile updated.',
  },
  nav: {
    resources: 'Resources',
    deployments: 'Deployments',
    config: 'Config & Secrets',
    observability: 'Observability',
    administration: 'Administration',
    logout: 'Sign Out',
    organization: 'Organization',
    createOrg: 'New Organization',
    editProfile: 'Edit Profile',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
  },
  orgCreate: {
    title: 'Create Organization',
    nameLabel: 'Organization Name',
    namePlaceholder: 'Enter organization name',
    nameRequired: 'Organization name is required.',
    submit: 'Create',
    creating: 'Creating…',
  },
  topbar: {
    selectApp: 'Select app...',
  },
  appSelector: {
    noApps: 'No apps available',
  },
  stageSelector: {
    allStages: 'All stages',
  },
  deployments: {
    title: 'Deployments',
    subtitle: 'Deployment history across all services and stages',
    detail: 'Deployment Detail',
    backToDeployments: 'Back to Deployments',
    retry: 'Retry',
    status: {
      pending: 'Pending',
      planning: 'Planning',
      awaiting_approval: 'Awaiting Approval',
      awaitingApproval: 'Awaiting Approval',
      deploying: 'Deploying',
      completed: 'Completed',
      failed: 'Failed',
      rolled_back: 'Rolled Back',
      rolledBack: 'Rolled Back',
    },
    source: {
      cli: 'CLI',
      console: 'Console',
      ci: 'CI/CD',
    },
    tab: {
      events: 'Events',
      changes: 'Changes',
      outputs: 'Outputs',
      stateJson: 'State JSON',
    },
    error: {
      title: 'Deployment Failed',
      unknown: 'Deployment failed without a recorded error message.',
    },
    timeline: {
      title: 'Deployment Timeline',
      noEvents: 'No deployment events recorded.',
      duration: 'Duration',
      phase: {
        start: 'Start',
        planning: 'Planning',
        apply: 'Apply',
        fail: 'Failed',
      },
      status: {
        done: 'done',
        failed: 'failed',
        inProgress: 'in-progress',
        diagnostic: 'diagnostic',
        planned: 'planned',
      },
    },
    table: {
      id: 'ID',
      service: 'Service',
      version: 'Version',
      source: 'Source',
      triggeredBy: 'Triggered By',
      commit: 'Commit',
      time: 'Time',
    },
    filter: {
      allStatuses: 'All statuses',
      allSources: 'All sources',
      allServices: 'All services',
      search: 'Search deployments...',
    },
    emptyTitle: 'No deployments yet',
    emptyDescription: 'Deploy your first service to see deployment history here.',
    rollback: 'Rollback',
    rollbackTitle: 'Rollback Deployment',
    rollbackDescription:
      'Are you sure you want to rollback {version} deployed {time} ago? This will revert the infrastructure state to the previous version.',
    rollbackConfirm: 'Yes, rollback',
    rollbackCancel: 'Cancel',
    changes: {
      title: 'Changes',
      noItems: 'No changes recorded for this deployment.',
      noPropertyChanges: 'No property-level changes.',
      actionCreate: 'CREATE',
      actionUpdate: 'UPDATE',
      actionDelete: 'DELETE',
      before: 'Before',
      after: 'After',
    },
    outputs: {
      noData: 'No output data available for this deployment.',
      noResources: 'No resources deployed.',
      section: {
        functions: 'Functions',
        apiGateway: 'API Gateway',
        storage: 'Storage',
        databases: 'Databases',
        dns: 'DNS Records',
        other: 'Other Resources',
      },
    },
    stateJson: {
      noData: 'No state data available.',
    },
    notFound: 'Deployment not found',
    notFoundDescription: 'The deployment you are looking for does not exist or has been removed.',
  },
  resources: {
    backToResources: 'Back to Resources',
    retry: 'Retry',
    quickStats: {
      totalServices: 'Total Services',
      totalResources: 'Total Resources',
      recentDeployments: 'Deployments (24h)',
    },
    serviceDetail: {
      resources: 'Resources',
      stages: 'Stages',
      created: 'Created',
    },
    resourceTable: {
      type: 'Type',
      name: 'Name',
      service: 'Service',
      region: 'Region',
      properties: 'Properties',
      search: 'Search resources...',
      noResults: 'No resources match your search.',
      emptyTitle: 'No resources found',
      emptyDescription: 'This app has no deployed resources yet.',
    },
    resourceDetail: {
      title: 'Resource Detail',
      resourceInfo: 'Resource Info',
      stage: 'Stage',
      cloudId: 'Cloud ID',
      properties: 'Properties',
      noProperties: 'No properties',
      linkedResources: 'Linked Resources',
      noLinked: 'No linked resources',
      deploymentHistory: 'Deployment History',
      noHistory: 'No deployment history',
      version: 'Version',
      source: 'Source',
      resourceCount: 'Resource Count',
      date: 'Date',
      close: 'Close',
      sourceDeploy: 'Deploy',
      sourceRollback: 'Rollback',
      sourceDrift: 'Drift Detected',
      sourceImport: 'Import',
      resourceIdFallback: '(Resource ID: {id})',
      reveal: 'Reveal value',
      mask: 'Mask value',
    },
    status: {
      healthy: 'Healthy',
      degraded: 'Degraded',
      error: 'Error',
      ready: 'Ready',
      running: 'Running',
      active: 'Active',
      updating: 'Updating',
      available: 'Available',
      unavailable: 'Unavailable',
      unknown: 'Unknown',
      creating: 'Creating',
      deleted: 'Deleted',
      paused: 'Paused',
      suspended: 'Suspended',
    },
    servicesTable: {
      search: 'Search services...',
      serviceName: 'Service Name',
      provider: 'Provider',
      stages: 'Stages',
      resources: 'Resources',
      lastDeployed: 'Last Deployed',
      noResults: 'No services match your search.',
      emptyTitle: 'No services found',
      emptyDescription: 'This app has no services yet.',
    },
    resourceType: {
      function: 'Function',
      'api-gateway': 'API Gateway',
      gateway: 'Gateway',
      'gateway-service': 'Gateway Service',
      api: 'API',
      trigger: 'Trigger',
      role: 'Role',
      'security-group': 'Security Group',
      storage: 'Storage',
      bucket: 'Bucket',
      database: 'Database',
      search: 'Search',
      table: 'Table',
      queue: 'Queue',
      topic: 'Topic',
      log: 'Log',
      cdn: 'CDN',
      cname: 'CNAME',
      'dns-verification': 'DNS Verification',
      deployment: 'Deployment',
      upstream: 'Upstream',
      route: 'Route',
      nas: 'NAS',
      domain: 'Domain',
      unknown: 'Unknown',
    },
  },
  admin: {
    title: 'Administration',
    subtitle: 'Organization, members, API keys, account billing, and audit logs.',
    accountScope: 'Account-wide · all organizations',
    tab: {
      billing: 'Billing',
      organization: 'Organization',
      members: 'Members',
      apiKeys: 'API Keys',
      auditLogs: 'Audit Logs',
    },
    billingSupport: {
      siteCurrency: 'Site default',
      title: 'Support details and account reconciliation',
      scopeNote:
        'Platform administrators only. Cross-account reads are audited. Verify payment evidence before moving funds.',
      search: 'Search',
      refresh: 'Refresh',
      filters: 'Filters',
      reconcile: 'Open reconciliation',
      all: 'All',
      details: 'Details',
      userFilter: 'User email or ID',
      userId: 'User ID (UUID)',
      ticketId: 'Ticket ID',
      orderId: 'Order / transaction / entry ID',
      currency: 'Currency',
      pagination: 'Pagination',
      pageInfo: 'Page {page} of {pages} · {total} results',
      previous: 'Previous',
      next: 'Next',
      loading: 'Loading…',
      resolution: 'Resolution',
      assignee: 'Assignee',
      updatedAt: 'Updated at',
      resolvedAt: 'Resolved at',
      completedAt: 'Completed at',
      noAccount: 'No billing account has been created for this user.',
      balanceCents: 'Settled balance',
      reservedCents: 'Reserved funds',
      availableBalanceCents: 'Available balance',
      arrearsCents: 'Arrears',
      entryType: 'Entry type',
      evidence: 'Ledger evidence',
      entryTypes: {
        topup: 'Top-up',
        deduction: 'Charge',
        repay: 'Arrears repayment',
        refund: 'Refund / hold',
        adjustment: 'Adjustment',
        annual: 'Annual plan',
      },
      ledgerStatuses: {
        pending: 'Pending',
        success: 'Successful',
        failed: 'Failed / cancelled',
      },
    },
    billingOps: {
      topupsTitle: 'Top-up orders',
      topupsNote:
        'Webhook-loss fallback: confirm manually ONLY after verifying the money arrived on the PSP side — same ledger transaction and idempotency keys as the webhook path.',
      ticketsTitle: 'Ticket review',
      ticketsNote: 'Review refund and invoice requests.',
      createdAt: 'Date',
      user: 'User',
      provider: 'Channel',
      category: 'Category',
      categoryOptions: {
        invoice: 'Invoice',
        refund: 'Refund',
      },
      summary: 'Summary',
      status: 'Status',
      statusOptions: {
        pending: 'Pending',
        approved: 'Approved',
        completed: 'Completed',
        rejected: 'Rejected',
        failed: 'Failed',
      },
      showAll: 'Show all',
      showActionable: 'Actionable only',
      expiresAt: 'Expires at',
      expiredBadge: 'Expired',
      amount: 'Amount',
      confirmTopup: 'Confirm & credit',
      approveIssue: 'Approve & issue',
      approveRefund: 'Approve',
      completeRefund: 'Complete',
      rejectTitle: 'Rejection reason',
      rejectPlaceholder: 'Enter the rejection reason',
    },
    orgSettings: {
      workspacesTitle: 'Apps',
      workspacesNote: 'Created by serverlessinsight.yml deploys · read-only',
      noWorkspaces: 'No apps yet — deploy with the CLI to create one.',
      wsName: 'Name',
      wsServices: 'Services',
      wsCreated: 'Created',
      wsUpdated: 'Last Modified',
      title: 'Organization Settings',
      name: 'Organization Name',
      slug: 'Slug',
      created: 'Created',
      createdBy: 'Created By',
      you: 'you',
      rename: 'Rename',
      renameSuccess: 'Organization renamed successfully.',
      renameError: 'Failed to rename organization.',
      nameRequired: 'Organization name is required.',
      delete: 'Delete Organization',
      deleteWarning:
        'This action cannot be undone. All apps, services, and data in this organization will be permanently deleted.',
      deleteConfirm: 'Delete',
      deleteSuccess: 'Organization deleted.',
      deleteError: 'Failed to delete organization.',
      noOrg: 'No organization selected.',
    },
    members: {
      email: 'Email',
      name: 'Name',
      role: 'Role',
      scope: 'Scope',
      app: 'App',
      created: 'Created',
      emptyTitle: 'No members found',
      emptyDescription: 'No team members to display.',
      fetchError: 'Failed to load members',
      retry: 'Retry',
      unnamed: '(Unnamed)',
      global: 'Global',
      deleteConfirmTitle: 'Remove Member',
      deleteConfirmMessage: 'Are you sure you want to remove {email}?',
      deleteConfirm: 'Remove',
    },
    apiKeys: {
      name: 'Name',
      status: 'Status',
      noOrg: 'Select or create an organization first.',
      key: 'Key',
      scopes: 'Scopes',
      source: 'Source',
      created: 'Created',
      actions: 'Actions',
      create: 'New API Key',
      createTitle: 'Create API Key',
      keyName: 'Key name',
      keyNamePlaceholder: 'e.g. deploy-cli',
      createError: 'Failed to create API key.',
      fullKeyLabel: 'Your API key',
      fullKeyWarning: 'Copy this key now. For security, it will not be shown again.',
      copy: 'Copy',
      copied: 'Copied!',
      copyError: 'Failed to copy to clipboard.',
      revokeConfirmTitle: 'Revoke API Key',
      revokeConfirmMessage: 'Are you sure you want to revoke "{name}"? This cannot be undone.',
      revokeConfirm: 'Revoke',
      revokeError: 'Failed to revoke API key.',
      statusActive: 'Active',
      statusDisabled: 'Disabled',
      statusRevoked: 'Revoked',
      sourceLogin: 'Login',
      sourceManual: 'Manual',
      emptyTitle: 'No API keys',
      emptyDescription: 'Create an API key to use with the ServerlessInsight CLI.',
      fetchError: 'Failed to load API keys',
      retry: 'Retry',
    },
    auditLogs: {
      action: 'Action',
      category: 'Category',
      severity: 'Severity',
      actor: 'Actor',
      resource: 'Resource',
      created: 'Created',
      filterAction: 'Filter by action...',
      allCategories: 'All categories',
      allSeverities: 'All severities',
      fromDate: 'From',
      toDate: 'To',
      clearFilters: 'Clear filters',
      emptyTitle: 'No audit logs found',
      emptyDescription: 'No audit events match your filters.',
      fetchError: 'Failed to load audit logs',
      retry: 'Retry',
      categoryOptions: {
        auth: 'Auth',
        deploy: 'Deploy',
        config: 'Config & Secrets',
        member: 'Member',
        security: 'Security',
        account: 'Account',
      },
      severityOptions: {
        info: 'Info',
        warning: 'Warning',
        critical: 'Critical',
      },
    },
  },
  observability: {
    title: 'Observability',
    subtitle: 'Recent infrastructure events timeline.',
    refresh: 'Refresh',
    emptyTitle: 'No audit events yet',
    emptyDescription: 'Infrastructure events will appear here as they occur.',
    fetchError: 'Failed to load events',
    retry: 'Retry',
    table: {
      action: 'Action',
      category: 'Category',
      severity: 'Severity',
      actor: 'Actor',
      resource: 'Resource',
      time: 'Time',
      search: 'Search events...',
      noResults: 'No events match your search.',
    },
    detail: {
      title: 'Event Detail',
      eventInfo: 'Event Info',
      details: 'Details',
      related: 'Related',
      viewDeployment: 'View Deployment Details',
      noDetails: 'No details',
      metadata: 'Metadata',
      ipAddress: 'IP Address',
      userAgent: 'User Agent',
      action: 'Action',
      category: 'Category',
      severity: 'Severity',
      actor: 'Actor',
      resource: 'Resource',
      time: 'Time',
      close: 'Close',
    },
  },
  config: {
    title: 'Config',
    subtitle: 'Manage configuration sets across your application.',
    emptyTitle: 'No config sets',
    emptyDescription: 'Create your first config set to manage application configuration.',
    noResults: 'No config sets match your filter.',
    newButton: 'New Config Set',
    scope: {
      all: 'All',
      global: 'Global',
      app: 'App',
      service: 'Service',
      stage: 'Stage',
    },
    table: {
      name: 'Name',
      scope: 'Scope',
      items: 'Items',
      tags: 'Tags',
      updated: 'Updated',
      actions: 'Actions',
    },
    modal: {
      titleNew: 'New Config Set',
      name: 'Name',
      description: 'Description',
      scope: 'Scope',
      items: 'Configuration Items',
      addItem: 'Add Item',
      key: 'Key',
      itemDescription: 'Description',
      changeSummary: 'Change Summary',
      saveVersion: 'Save as Version',
      create: 'Create Config Set',
      cancel: 'Cancel',
      deleteWarning: 'This will permanently delete the config set and all its versions.',
      delete: 'Delete',
      noItems: 'Add at least one configuration item.',
      editHint: 'Editing an existing config set. Changes are saved as a new version.',
    },
    itemType: {
      string: 'String',
      number: 'Number',
      boolean: 'Boolean',
      json: 'JSON',
      yaml: 'YAML',
      text: 'Text',
      secret: 'Secret',
    },
    version: {
      title: 'Version History',
      noVersions: 'No versions',
      current: 'Current',
      promote: 'Promote to Latest',
      promoting: 'Promoting...',
      by: 'by',
    },
    strategy: {
      title: 'Deployment Strategy',
      saved: 'Strategy updated',
      mode: 'Strategy',
      allAtOnce: 'All at Once',
      linear: 'Linear',
      canary: 'Canary',
      autoRollback: 'Auto-rollback',
      enabled: 'Enabled',
      disabled: 'Disabled',
      threshold: 'Rollback Threshold',
      thresholdUnit: '% error rate',
      interval: 'Interval',
      intervalUnit: 'seconds',
      observationWindow: 'Observation Window',
      observationUnit: 'minutes',
    },
    healthStatus: {
      healthy: 'Healthy',
      degraded: 'Degraded',
      failed: 'Failed',
      rollingBack: 'Rolling Back',
    },
    promoteComingSoon: 'Promote functionality coming soon',
    meta: {
      saved: 'Config set updated',
    },
    detail: {
      backToConfig: 'Back to Config',
      items: 'Configuration Items',
      saveDescription: 'Describe what changed in this version.',
      versionLabel: 'Version',
      saveVersion: 'Save as Version',
      editMeta: 'Edit Config Set',
      selectService: 'Select service...',
      selectStage: 'Select stage...',
    },
    deleteConfirm: {
      title: 'Delete Config Set',
      description:
        'This action cannot be undone. All versions of this config set will be permanently removed. Please type the config set name to confirm.',
      typeToConfirm: 'Type the config set name to confirm:',
      cancel: 'Cancel',
      delete: 'Delete',
    },
  },
  cliAuthorize: {
    title: 'CLI Authorization',
    redirecting: 'Redirecting you back to the CLI...',
    retry: 'Retry',
    goToOnboarding: 'Go to Onboarding',
    closeWindowHint: 'You can close this window after the CLI confirms the login.',
    selectOrg: 'Choose an organization',
    selectKey: 'Choose an API key',
    createNewKey: 'Create new key',
    keyListEmpty: 'No existing keys for this organization.',
    keyListLoading: 'Loading keys...',
    confirm: 'Authorize',
    keySourceLogin: 'Login',
    keySourceManual: 'Manual',
    rotateHint: 'A new secret will be issued. The previous secret will stop working.',
    errors: {
      invalidRedirect: 'Invalid or missing redirect_uri. This authorization link is malformed.',
      noOrg: 'You need an organization before you can authorize the CLI. Create one first.',
      createFailed: 'Failed to create an API key. Please try again.',
    },
  },
  billing: {
    annual: {
      activeUntil: 'Annual plan active until {date}',
      pitch:
        'Team annual {price}/yr (billed as 10 months, save 17%) — covers 12 months of the plan base fee from the next billing period; overage still bills at {overage}/AMR from your balance.',
      buy: 'Annual plan (10-month price)',
      autoRenew: 'Auto-renew from balance in the last 30 days of coverage',
      cancelRenewal: 'Cancel the renewed period (refund to balance)',
      cancelled: 'Renewed period cancelled — {amount} returned to your balance',
      purchased: 'Annual plan activated — coverage until {until}, paid from your balance',
    },
    usage: {
      amr: 'AMR usage',
      members: 'Members',
      workspaces: 'Orgs',
      budgetAlert: 'Monthly bill reached {percent}% of your budget cap.',
      comparePlans: 'Compare plans',
    },
    budget: {
      capLabel: 'Budget cap ({currency} / month, empty = unlimited)',
      alertNote:
        'The daily check emails the billing owner when the current estimate reaches this threshold, once per threshold per billing period.',
      capPlaceholder: 'e.g. 50',
      thresholdLabel: 'Alert threshold',
      save: 'Save',
      saved: 'Budget saved.',
    },
    balance: {
      title: 'Balance',
      available: 'Available balance',
      arrears: 'Arrears',
      arrearsBadge: 'In arrears',
      arrearsLine: 'arrears {amount}',
      arrearsHint:
        'This account is in arrears: creating new resources is blocked (existing ones keep running). Your next top-up repays the arrears first.',
      lowBadge: 'Low balance',
      lowHint:
        'At your last-30-day daily average the balance will run out soon — consider topping up.',
      daysRemaining:
        'Estimated ≈ {days} days of consumption left at your last-30-day daily average',
      noConsumptionYet: 'No consumption yet — the burn-rate estimate appears after the first bill.',
      topup: 'Top up',
      topupNow: 'Top up',
      refund: 'Refund',
      advanced: 'Advanced',
      invoicing: 'Invoicing',
    },
    topup: {
      title: 'Top up balance',
      creating: 'Creating payment…',
      paymentMethod: 'Payment method',
      paymentMethods: { alipay: 'Alipay', creem: 'Creem', waffo: 'Waffo Checkout', stripe: 'Stripe' },
      payWithProvider: 'Top up with {provider}',
      checkoutNotice: 'You’ll continue to {provider} to complete payment. Your balance updates after payment is confirmed.',
      customLabel: 'Custom amount (min {min})',
      customPlaceholder: 'e.g. 88',
      customTooSmall: 'A single top-up must be at least {min}.',
      customTooLarge: 'A single top-up cannot exceed {max}.',
      unavailable:
        'Online top-up is not enabled on this deployment — contact sales or use a bank transfer.',
      createdTitle: 'Top-up order created',
      createdBody:
        'Once paid, the balance is credited automatically (usually instant — no manual confirmation).',
      resumeCheckout: 'Reopen the checkout page',
      returned: {
        checking: 'Checking payment confirmation…',
        confirmed: 'Payment confirmed. Your balance has been updated.',
        pending: 'Payment has not been confirmed yet. If you have been charged, please do not pay again. Retry later or contact support.',
        error: 'Unable to check payment confirmation. Please retry.',
        awaitingCredit: 'Awaiting payment confirmation',
      },
      provider: {
        manual: 'Online top-up is not enabled on this deployment (manual mode).',
        alipay:
          'Payment: Alipay (desktop checkout) — the balance is credited automatically after payment.',
        creem:
          'Payment: Creem (card / international) — the balance is credited automatically after payment.',
        waffo: 'Payment: Waffo Checkout — the balance is credited automatically after payment.',
        stripe:
          'Payment: Stripe (card / international) — the balance is credited automatically after payment.',
      },
      pending: {
        title: 'Pending top-ups',
        banner: '{count} awaiting payment — resume or cancel',
        resume: 'Resume payment',
        cancel: 'Cancel',
        cancelled: 'Top-up order cancelled.',
        expiredBadge: 'Expired',
        expiredHint: 'if you already paid, contact support to verify the credit.',
      },
    },
    refund: {
      title: 'Balance refund',
      policyNote:
        'Only unconsumed, un-invoiced balance is refundable (via the original payment route). Requests are reviewed by a platform admin.',
      refundable: 'Refundable amount',
      all: 'All',
      amountLabel: 'Refund amount',
      overLimit: 'The refund amount cannot exceed the refundable balance.',
      minHint: 'A single refund must be at least {min}.',
      belowMin: 'A single refund must be at least {min}.',
      refundBelowMin:
        'The refundable balance is below the {min} minimum — contact support if you need a refund.',
      reasonLabel: 'Reason',
      reasonPlaceholder: 'e.g. accidental top-up / duplicate payment',
      submit: 'Submit refund request',
      submittedNote:
        'Refund request submitted — a platform admin will review and refund via the original route.',
      loadError: 'Could not load refund information — please refresh.',
      historyTitle: 'Recent refund requests',
      status: {
        pending: 'Pending review',
        approved: 'Approved (processing)',
        rejected: 'Rejected',
        completed: 'Completed',
        failed: 'Failed',
      },
    },
    invoiceCenter: {
      title: 'Invoicing',
      policyNote: 'Invoiced per top-up · title must match the realname profile',
      realnameTitle: 'Realname profile (invoice subject)',
      realnameType: 'Subject type',
      typeCompany: 'Company',
      typePersonal: 'Individual',
      companyName: 'Company name',
      personalName: 'Full name',
      taxId: 'Tax ID',
      contactEmail: 'Delivery email',
      saveProfile: 'Save profile',
      profileSaved: 'Realname profile saved.',
      realnameNote:
        'The invoice title must exactly match the realname profile; a platform admin re-checks it at invoice review.',
      invoicableTitle: 'Invoicable amount ({amount})',
      amountLabel: 'Amount to invoice',
      amountHint: 'Up to the invoicable amount of {max}.',
      amountInvalid: 'The invoice amount must be between 0 and {max}.',
      loadError: 'Could not load invoicing information — please refresh.',
      noInvoicable: 'No invoicable top-ups.',
      needRealnameFirst:
        'Complete the realname profile first — the invoice title must match it exactly.',
      appliedNote:
        'Invoice request submitted — the e-invoice will be delivered to your email once approved.',
      apply: 'Apply for invoice ({amount})',
      requestDate: 'Date',
      requestTitle: 'Title',
      requestStatus: 'Status',
      requestAmount: 'Amount',
      status: {
        pending: 'Pending review',
        approved: 'Approved',
        completed: 'Issued',
        rejected: 'Rejected',
        failed: 'Failed',
        issued: 'Issued',
      },
    },
    summaryUnavailable: 'Could not load billing information — please retry.',
    blocked: {
      title: 'Action blocked by billing',
      modalTitle: 'Billing limit reached',
      manage: 'Manage Billing',
      reason: {
        INSUFFICIENT_BALANCE:
          'Your balance is empty or in arrears — top up to keep creating resources. Existing resources are not affected.',
        QUOTA_EXCEEDED: 'Plan quota exceeded — upgrade your plan to continue.',
        ACCOUNT_SUSPENDED: 'This billing account is suspended — contact support.',
      },
    },
    invoices: {
      noLineItems: 'No charges for this period.',
      kind: {
        base: 'Base fee',
        amr_overage: 'AMR overage',
      },
    },
    upgradeBanner: {
      text: 'Your monthly bill is climbing — Team {price}/mo includes {amr} AMR, {members} members and auto-deploy.',
      cta: 'View plans',
    },
    checkout: {
      title: 'Upgrade to {plan}',
      current: 'Current plan',
      currentUsage: 'Current usage',
      after: 'After upgrade',
      price: 'Price',
      prorationNote:
        'The first month is prorated by day — you only pay for the days on the new plan.',
      effectNote:
        'Takes effect immediately when the balance covers the prorated month; the bill is charged from the balance at issuance.',
      paymentTitle: 'Balance payment',
      paymentBody:
        'Prepaid balance model (issue #38): plan changes no longer collect payment separately — the balance must cover the prorated month, which is charged at issuance.',
      submit: 'Validate balance & upgrade',
      submitting: 'Applying upgrade…',
      submittedTitle: 'Upgrade applied',
      submittedBody:
        "Balance check passed — the new plan is effective immediately. This month's bill will be charged from your balance, prorated by day.",
    },
    resourceTypes: {
      ALIYUN_FC3_FUNCTION: 'Function Compute FC3 (Aliyun)',
      SCF_FUNCTION: 'Serverless Cloud Function SCF (Tencent)',
      VOLCENGINE_VEFAAS_FUNCTION: 'Function Service VeFaaS (Volcengine)',
      ALIYUN_OSS_BUCKET: 'Object Storage OSS (Aliyun)',
      COS_BUCKET: 'Object Storage COS (Tencent)',
      VOLCENGINE_TOS_BUCKET: 'Object Storage TOS (Volcengine)',
      ALIYUN_RDS_SERVERLESS: 'ApsaraDB RDS Serverless (Aliyun)',
      TDSQL_C_SERVERLESS: 'TDSQL-C Serverless (Tencent)',
      ALIYUN_ES_SERVERLESS: 'Elasticsearch Serverless (Aliyun)',
      ALIYUN_APIGW_GROUP: 'API Gateway Group (Aliyun)',
      ALIYUN_SLS_PROJECT: 'Log Service SLS Project (Aliyun)',
      ALIYUN_SLS_LOGSTORE: 'Log Service SLS Logstore (Aliyun)',
      ALIYUN_SLS_INDEX: 'Log Service SLS Index (Aliyun)',
      TENCENT_CLS_LOGSET: 'Log Service CLS Logset (Tencent)',
      TENCENT_CLS_TOPIC: 'Log Service CLS Topic (Tencent)',
      ALIYUN_APIGW_API: 'API Gateway API (generated)',
      ALIYUN_APIGW_DEPLOYMENT: 'API Gateway Deployment (generated)',
      ALIYUN_APIGW_LOG_CONFIG: 'API Gateway Log Config (generated)',
      ALIYUN_CDN_DISTRIBUTION: 'CDN Distribution (edge, from bucket.cdn)',
      ALIYUN_NAS_FILE_SYSTEM: 'NAS File System (edge, from function.nas)',
      ALIYUN_NAS_MOUNT_TARGET: 'NAS Mount Target (generated)',
      ALIYUN_NAS_ACCESS_GROUP: 'NAS Access Group (generated)',
      ALIYUN_TABLESTORE_TABLE: 'Tablestore Table (Aliyun)',
    },
    subscription: {
      yourPlan: 'Current plan',
      unlockTitle: 'Upgrade to {plan} to unlock',
      unlockPitch: 'Everything in your current plan, plus:',
      upgradeTo: 'Upgrade to {plan}',
      upgradeToWithPrice: 'Upgrade to {plan} · {price}/mo',
      overageCheaper: 'Cheaper overage: {price}/AMR (currently {current}/AMR)',
      topTierTitle: 'Top tier',
      topTierNote: 'You are on the highest plan — contact sales for larger quotas.',
      usageSection: 'Usage',
      budgetSection: 'Budget',
      cloudView: 'Cross-cloud view',
      overageTitle: 'Pay-as-you-go beyond the quota',
    },
    usageDetails: {
      noCap: 'No budget cap set',
      burnHint: '{percent}% of your monthly budget used.',
      limitsTitle: 'Subscription & budget',
      plan: {
        developer: 'Developer',
        team: 'Team',
        enterprise: 'Enterprise',
      },
      footprint: 'Live AMR footprint',
      footprintHint:
        'org → service → stage, drill down to resource types × instances × weight — every number traces back to the bill.',
      managed: 'managed',
      instances: 'instances',
      paygTooltip: 'Reference: billed at {price}/AMR once the free quota is exceeded',
      workspaceFolding: 'Orgs beyond included: {extra} × +1 AMR = {amr} AMR',
    },
    trend: {
      title: 'Usage trend',
      hint: 'Last 6 billing periods — billed amount vs amount charged from the balance (pure CSS chart).',
      billed: 'Billed',
      charged: 'Charged',
      arrears: 'arrears {amount}',
      arrearsHint:
        'The uncovered part of the bill was booked as arrears and is repaid by the next top-up.',
      empty: 'No bills yet — the first monthly charge appears here.',
    },
  },
  pricing: {
    title: 'Pricing',
    nav: {
      login: 'Sign in',
      register: 'Get started',
      backToConsole: 'Back to console',
    },
    hero: {
      title: 'Simple pricing that scales with you',
      subtitle:
        'One unit for everything: AMR. Each instance of a declared entity — function, gateway, bucket, database, table — weighs 1 AMR. Start free on Developer with 10 AMR, upgrade to Team when you outgrow it.',
      monthlyOnly: 'Monthly billing (annual plans coming later)',
    },
    common: {
      month: 'mo',
      custom: 'Contact sales',
    },
    cards: {
      popular: 'Most popular',
      yourPlan: 'Your plan',
      amrQuota: '{n} AMR included',
      amrQuotaCustom: 'AMR allowance by contract',
      teamValue:
        '{included} AMR included — worth {worth} at Developer pay-as-you-go rates, only {price}',
      autoDeploy: 'Auto deploy',
      billedFromBalance: 'billed from balance',
    },
    cta: {
      startFree: 'Start for free',
      upgrade: 'Upgrade to Team',
      currentPlan: 'Current plan',
      contactSales: 'Contact sales',
      downgrade: 'Downgrade to Developer',
    },
    feat: {
      overage: '{price} / AMR beyond quota',
      overageCustom: 'Custom overage rate',
      members: '{n} members (hard quota)',
      membersUnlimited: 'Unlimited members',
      workspaces: '{n} orgs included',
      workspacesUnlimited: 'Unlimited orgs',
      workspaceOverage: '+{amr} AMR per extra org',
    },
    spec: {
      views: {
        readonly: 'Read-only passthrough',
        full: 'Unified cross-cloud search',
      },
      alertOnly: 'Alerts only',
      supportOptions: {
        developer: 'Community',
        team: 'Tickets · 1 business day',
        enterprise: 'Dedicated TAM · 7×24',
      },
    },
    pricing: {
      title: 'Resource pricing',
      subtitle:
        'Billed per declared-entity instance — each instance costs its weight in AMR per month.',
      resource: 'Resource',
      amrCol: 'AMR / instance · mo',
      free: 'Free',
      groupLabel: 'Weight {weight}',
      zeroGroupLabel: '0 AMR — the ones below are always free',
      workspaceRow: 'Org (beyond the included count)',
      workspaceWeightNote: 'per org · mo',
      amrPriceNote:
        '1 AMR beyond the quota: Developer {dev} · Team {team} — free of charge within the free quota.',
      enterpriseNote: 'Enterprise rates are contract-defined (at or below list price).',
    },
    breakdown: {
      title: 'How billing works',
      coversTitle: 'What one AMR covers',
      coversIntro: 'Each AMR covers any one of the below for a month.',
      fnName: 'Function instance',
      fnDetail: 'FC3 · SCF · VeFaaS',
      apigwName: 'API gateway group',
      apigwDetail: 'per group',
      bucketName: 'Object storage bucket',
      bucketDetail: 'OSS · COS · TOS',
      dbName: 'Serverless database',
      dbDetail: 'RDS · TDSQL-C · ES',
      tableName: 'Data table',
      tableDetail: 'Tablestore',
      wsName: 'Extra workspace',
      wsDetail: 'beyond the included count',
      perInstance: '/ instance · mo',
      perWorkspace: '/ workspace · mo',
      zeroName: 'Auto-generated plumbing',
      zeroDetail: 'logs · roles · API deployments · domains · mounts',
      zeroBadge: '0 AMR · always free',
      exampleTitle: 'Worked example',
      exampleNote:
        'Free of charge within the Developer free quota of {free} AMR/mo; beyond it the plan rate applies.',
      rulesTitle: 'Billing rules',
      rule1: 'A stage counts when alive ≥ 14 days AND it had a successful deployment that month',
      rule2: 'personal-* stages are permanently free (up to 2 per org)',
      rule3: 'Settled monthly on the 1st at 00:00 UTC — nothing is charged within the free quota',
      rule4:
        'Developer budget: alert at 80%, block new deploys at 100% — existing resources are never touched',
      rule5:
        'Mid-month upgrades prorate by day; downgrades take effect on the 1st of the next month',
    },
    faq: {
      title: 'FAQ',
      q1: 'Is the Developer plan really free?',
      a1: 'Yes — within the free quota (10 AMR, 1 member, 1 workspace) it is free forever, no prepayment needed. Beyond the quota: top up your balance for pay-as-you-go, or set a hard budget cap to stay on top of it.',
      q2: 'When does upgrading to Team pay off?',
      a2: 'Team costs {teamPrice}/month with {amr} AMR included — worth {worth} when converted at the Developer pay-as-you-go rate ({payg}/AMR). When your monthly bill approaches {alert} (80% of Team), the console suggests upgrading; beyond the included {amr} AMR each additional AMR is only {teamOverage}, half the Developer rate.',
      q3: 'How do I pay?',
      a3: 'Start a top-up from the console and pay on the hosted Checkout page with an international card or a common wallet — the balance is credited instantly, never expires, and all usage is deducted from it (the balance can never go negative).',
      q4: 'What happens when I hit the free quota without a balance?',
      a4: 'Nothing breaks. Existing resources keep running, but new deployments are paused once AMR usage (including extra workspaces) passes the free quota — they resume automatically once you top up. Members are a hard quota on every plan: the 2nd Developer member needs an upgrade.',
      q5: 'Can I downgrade back to Developer?',
      a5: 'Yes — self-service from the Billing tab. It takes effect the first day of the next month; if usage then exceeds the Developer free quota, new deployments are paused (top up your balance to resume).',
      q6: 'Do prices include taxes?',
      a6: 'Displayed prices are pre-tax list prices. Tax handling depends on your region and payment channel — international payments go through our merchant of record (Creem), which handles VAT / sales tax.',
      q7: 'Why does 1 function = 1 AMR, instead of pricing every raw resource?',
      a7: 'Because you think in deliverables, not plumbing. Each entity you declare in yml — a function, a bucket, a table — is one manageable unit and weighs 1 AMR; the resources generated underneath it (log stores, execution roles, API deployments, domain bindings, mount targets) are billed at 0. That keeps the bill predictable and never punishes you for wiring things up properly.',
    },
  },
}
